import { Col, EventHandler, InputField, Label, Row } from "client/CommonComponents"
import { MultiSelect } from '@softura/customcomponent'
import './AddModel.scss'
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup"

const AddModel = (props: any) => {
    const {
        selectedMake,
        selectedModel,
        handleModelChange,
        handleMakeChange,
        makeList,
        removeItem,
        ExistingDropDownValue,
        hideDialogComplete,
        PopupcontentComplete,
        modelError,
        modelMakeError
    } = props
    return (
        <Row>
            <Col xs={12} sm={12} className='mb-3'>
                <Label required data-attribute="AddModel_Default_Label">Model</Label>
                <InputField
                    placeholder="Enter Model"
                    name="model"
                    value={selectedModel}
                    className={modelError?.length ? 'controlValidation' : ""}
                    onChange={(e: any) => handleModelChange(e)}
                 data-attribute="AddModel_model_Input" />
                {modelError?.length ? <p className='validMessage'>{modelError}</p> : null}
            </Col>
            <Col xs={12} sm={12} className='mb-3'>
                <Label required data-attribute="AddModel_Default_Label_2">Make</Label>
                <MultiSelect
                    name='vehicleLevel'
                    value={selectedMake || []}
                    onChange={(value: any) => handleMakeChange(value)}
                    options={makeList ?? []}
                    className={modelMakeError?.length ? 'controlValidation' : ""}
                    closeOnChangedValue={true}
                />
                {modelMakeError?.length ? <p className='validMessage'>{modelMakeError}</p> : null}
            </Col>
            {ExistingDropDownValue?.length ? <ul className='added-vehicle-level-list'>
                {ExistingDropDownValue?.map((item: any, index: any) => (
                    <li
                        key={index}
                        className={"todo-list__list-item"}
                    >
                        <span className="item" title={item?.text}>{item?.text}</span>
                        <li
                            key={index}
                            className={"todo-list__list-item"}
                        >
                            <span className="item" title={item?.text}>{item?.text}</span>
                            <EventHandler onEvent={() => removeItem(item)} data-attribute={`AddModel_${((item?.text || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                                <span className="fa fa-trash-o delete-icon"></span>
                            </EventHandler>
                        </li>
                    </li>
                ))}
            </ul> : ''}
            <CompleteConfirmationPopup
                hideDialog={hideDialogComplete}
                onDismiss={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
                Popupcontent={PopupcontentComplete}
                popupOutlinebtnOnclick={PopupcontentComplete?.popupOutlinebtnOnclickComplete}
                popupPrimarybtnOnclick={PopupcontentComplete?.popupPrimarybtnOnclick}
            />
        </Row>
    )
}

export default AddModel